import { parseMdYDate } from './dateUtils';

// User-facing message rendered in DriverSelectorCell's dispatch warning dialog
// when needsNotReceivingWarning() returns true.
export const NOT_RECEIVING_WARNING_MESSAGE = 'Port is not yet receiving.';

/**
 * Checks whether a driver assignment should trigger a "not yet receiving" warning.
 *
 * Conditions (all must be true):
 *   1. The order's moveType is EXPORT
 *   2. The dispatch group contains a TERMINATE leg
 *   3. The order's firstRcvDate is later than the terminate leg's destApptDate
 *      (or, when that dest appt date is blank, later than today)
 *
 * The terminate leg's dest appt is the time we're trying to drop the empty at the
 * port; firstRcvDate is when the port begins accepting it. If receive opens after
 * the appointment, we'd be turned away.
 */
export function needsNotReceivingWarning(params: {
  moveType?: string;
  firstRcvDate?: string;
  dispatchGroupLegs: { legtype?: string; destApptDate?: string }[];
}): boolean {
  const { moveType, firstRcvDate, dispatchGroupLegs } = params;

  if (!moveType || moveType.toUpperCase() !== 'EXPORT') return false;

  const terminateLeg = dispatchGroupLegs.find(
    (l) => l.legtype && l.legtype.toUpperCase() === 'TERMINATE'
  );
  if (!terminateLeg) return false;

  const firstRcv = parseMdYDate(firstRcvDate);
  if (!firstRcv) return false;

  const termDest = parseMdYDate(terminateLeg.destApptDate);
  if (termDest) {
    return firstRcv > termDest;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return firstRcv > today;
}
